<template>
  <div class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card">
    <div class="card text-center">
      <h2
        v-if="isAdmin && groupAdminsEnabled"
        class="text-black uppercase -mt-2 py-1 text-base bg-yellow"
      >
        <span v-text="'Admin'" />
      </h2>
      <div class="card-bio-content relative">
        <div @click.stop>
          <DotPopper
            v-if="canGroupAdminEditMembershipGroup"
            :options="{ placement: 'bottom-end' }"
          >
            <div
              slot="content"
              class="flex flex-col"
            >
              <a
                :href="editLink"
                v-text="'Edit'"
              />
            </div>
          </DotPopper>
        </div>
        <h6
          class="text-blue uppercase -mt-2 mb-4"
          v-text="membershipStatus"
        />
        <a
          href="#"
          @click.prevent="visitProfile"
        >
          <img
            v-if="avatarUrl"
            :src="avatarUrl"
            alt=""
            class="rounded-full"
          >
        </a>
        <h4
          class="mb-4"
          v-text="fullName"
        />
        <div
          v-if="canGroupAdminEditMembershipGroup"
          class="w-32 mx-auto"
        >
          <input
            :id="`remove-${membership.uuid}`"
            :name="`remove-${membership.uuid}`"
            :checked="removalQueue.includes(membership.uuid)"
            :disabled="groupAdminQueue.length > 0"
            :aria-disabled="groupAdminQueue.length > 0"
            type="checkbox"
            @click="$emit('toggleMemberForRemoval', membership)"
          >
          <label
            :for="`remove-${membership.uuid}`"
            :class="{ 'text-grey-dark': groupAdminQueue.length > 0 }"
            v-text="'Remove from Group'"
          />
        </div>
        <div
          v-if="groupAdminsEnabled"
          v-can="'edit-membership-groups'"
          class="w-32 mx-auto whitespace-no-wrap"
        >
          <input
            :id="`group-admin-${membership.uuid}`"
            :name="`group-admin-${membership.uuid}`"
            :checked="groupAdminQueue.includes(membership.uuid)"
            :disabled="removalQueue.length > 0"
            :aria-disabled="removalQueue.length > 0"
            type="checkbox"
            @click="$emit('toggleGroupAdminAbilities', membership)"
          >
          <label
            :for="`group-admin-${membership.uuid}`"
            :class="{ 'text-grey-dark': removalQueue.length > 0 }"
            v-text="isAdmin ? 'Remove Admin Abilities' : 'Make Group Admin'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import DotPopper from 'Base/Resources/assets/js/components/DotPopper'

export default {
  name: 'MembershipGroupMember',
  components: {
    DotPopper,
  },
  props: {
    membership: {
      type: Object,
      required: true,
    },
    groupAdminsEnabled: {
      type: Boolean,
      required: true,
    },
    canGroupAdminEditMembershipGroup: {
      type: Boolean,
      required: true,
    },
    removalQueue: {
      type: Array,
      required: true,
    },
    groupAdminQueue: {
      type: Array,
      required: true,
    },
  },
  computed: {
    membershipStatus() {
      return this.membership.attributes.deactivated
        ? 'Deactivated'
        : _.upperFirst(this.membership.attributes.status)
    },
    fullName() {
      return `${this.membership.attributes.first_name} ${this.membership.attributes.last_name}`
    },
    avatarUrl() {
      return this.membership.attributes.small_avatar_url
    },
    isAdmin() {
      return this.membership.attributes.is_group_admin
    },
    editLink() {
      return this.$urlGenerator.active(`members/${this.membership.uuid}/edit`)
    },
  },
  methods: {
    visitProfile() {
      window.location = this.$urlGenerator.active(`members/${this.membership.uuid}`)
    },
  },
}
</script>
